import React, { useState } from "react"
import PropTypes from "prop-types"
import { Row, Col, Tabs } from "antd"
import { useTranslation } from "react-i18next"
import GuideAbout from "../GuideAbout/index"
import GuideExperiences from "../GuideExperiences/index"
import GuideLocation from "../GuideLocation/index"
import GuideEquipment from "../GuideEquipment/index"
import GuideReviews from "../GuideReviews/index"
import styles from "./index.module.css"

const GuideNavigationTabs = ({ className }) => {
  const [activeTab, setActiveTab] = useState("about")

  const classes = []
  if (className) classes.push(className)

  const { t } = useTranslation()

  const tabs = [
    { key: t("guide.navigation.about.key"), label: t("guide.navigation.about.label"), component: <GuideAbout /> },
    { key: t("guide.navigation.experiences.key"), label: t("guide.navigation.experiences.label"), component: <GuideExperiences /> },
    { key: t("guide.navigation.location.key"), label: t("guide.navigation.location.label"), component: <GuideLocation /> },
    { key: t("guide.navigation.equipment.key"), label: t("guide.navigation.equipment.label"), component: <GuideEquipment /> },
    { key: t("guide.navigation.reviews.key"), label: t("guide.navigation.reviews.label"), component: <GuideReviews /> }
  ]

  return (
    <nav className={classes.join(" ")}>
      <Row justify="center">
        <Col span={24}>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabs.map((tab) => ({
              key: tab.key,
              label: (
                <span className={styles.tabLabel + (activeTab === tab.key ? ' ' + styles.activeTabLabel : '')}>
                  {tab.label}
                </span>
              )
            }))}
            tabBarGutter={24}
            className="mt-l"
          />
          <div className="mt-l">{tabs.find((tab) => tab.key === activeTab)?.component}</div>
        </Col>
      </Row>
    </nav>
  )
}

GuideNavigationTabs.propTypes = {
  className: PropTypes.string
}

export default GuideNavigationTabs
